import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { Edit, TrashAlt } from '@styled-icons/boxicons-solid'
import { Menu } from '@styled-icons/boxicons-regular/Menu'

import Pagination from '../common/Pagination'
import { ProgresSpinner } from '../common/ProgresSpinner'
import LinkWithStatus from '../common/LinkWithStatus'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { deleteRequest } from '../../services/base'
import NoRecordsFound from '../common/NoRecordsFound'
import DropDownMenu from '../common/DropDownMenu'
import InputText from '../common/InputText'
import Button from '../common/Button'
import { NavContext } from '../../context/global_context'
import {
  PROMOTE_CHANGES,
  TRACER_PREVIEW,
  TRACER_PREVIEW_MGMT,
} from '../../constants/permission'
import { HasPermission } from '../../utils/permission'

const BlockedVehicleRow = (props) => {
  const blockers = props.blockers
  const messages = {
    wire_list: 'Importing Wirelist',
    dtcs: 'Importing DTCs',
    modules: 'Importing Modules',
    inlines: 'Importing Inlines',
    category_connector: 'Importing Connector Categories',
    harness_description: 'Importing Harness Descriptions',
    sig_list: 'Importing Circuit List',
    device_connections: 'Importing Device Connecitons',
    generating_wires: 'Wire Generation is in progress',
  }

  const state = blockers.map((b) => messages[b.name]).join('. ')

  return (
    <div className="w-2/3 font-light justify-end space-x-5 flex pr-5">
      <ProgresSpinner caption={state} />
    </div>
  )
}

const VehicleRow = (props) => {
  const vehicle = props.vehicle
  const blockers = (vehicle.blockers || []).filter(
    (b) => b.name !== 'graph_reset'
  )
  const vehicleIsBlocked = blockers.length > 0
  const [show, setShow] = useState(false)

  const showDropDown = (value) => {
    setShow(value)
  }

  return (
    <div className="flex flex-row items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue">
      <div className="w-1/3">
        <div className="font-medium"> {vehicle.name} </div>
        <div className="text-xs font-light">
          Make Model ID: {vehicle.make_model_id} | Last import:{' '}
          {vehicle.last_imported_at}
        </div>
      </div>

      {vehicleIsBlocked && <BlockedVehicleRow blockers={blockers} />}

      {!vehicleIsBlocked && (
        <div className="w-2/3 font-light text-right space-x-5 items-center flex justify-end">
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/power_distributions`}
            className="btn py-1 px-2"
            title="Power Distribution"
          />

          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/importers`}
            className="btn py-1 px-2"
            title="Importers"
          />
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/dtcs`}
            className="btn py-1 px-2"
            title="DTCs"
          />

          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/connector_views`}
            className="btn py-1 px-2"
            title="Vehicle Views"
          />

          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/edit`}
            className="btn py-1 px-2"
            title="Edit"
          >
            <Edit size="1.5rem" color="white" />
          </LinkWithStatus>
          <LinkWithStatus
            href={`/vehicles/${vehicle.vehicle_id}/edit`}
            className="btn py-1 px-2"
            title="Delete"
            onClickFunc={() => {
              props.deleteVehicle(vehicle.vehicle_id)
            }}
          >
            <TrashAlt
              size="1.5rem"
              color="white"
              onClick={() => showDropDown(!show)}
            />
          </LinkWithStatus>
          <DropDownMenu
            items={[
              {
                name: 'Plugin',
                value: 'plugin',
                childrens: [
                  {
                    name: 'Sales Code Complexity',
                    value: 'sales_code_complexity',
                    href: `/vehicles/${vehicle.vehicle_id}/plugin#sales_code_complexity`,
                  },
                  {
                    name: 'Def Plugin',
                    value: 'def_plugin',
                    href: `/vehicles/${vehicle.vehicle_id}/plugin#def_plugin`,
                  },
                  {
                    name: 'Capital Harness',
                    value: 'capital_harness',
                    href: `/vehicles/${vehicle.vehicle_id}/plugin#capital_harness`,
                  },
                ],
              },
              {
                name: 'Inlines',
                value: 'inlines',
                href: `/vehicles/${vehicle.vehicle_id}/inlines`,
              },
              {
                name: 'Modules',
                value: 'module',
                href: `/vehicles/${vehicle.vehicle_id}/modules`,
              },
              {
                name: 'Devices',
                value: 'devices',
                href: `/vehicles/${vehicle.vehicle_id}/devices`,
              },
              {
                name: 'Inspection Points',
                value: 'inspection_points',
                href: `/vehicles/${vehicle.vehicle_id}/inspection_points`,
              },
              {
                name: 'Wires',
                value: 'wires',
                href: `/vehicles/${vehicle.vehicle_id}/wire`,
              },
              {
                name: 'Connector',
                value: 'connector',
                href: `/vehicles/${vehicle.vehicle_id}/connector`,
              },
              {
                name: 'Sales Code',
                value: 'sales_code',
                href: `/vehicles/${vehicle.vehicle_id}/sales_code`,
              },
              {
                name: 'Functional Diagram',
                value: 'functional_diagram',
                href: `/vehicles/${vehicle.vehicle_id}/functional-diagram`,
              },
              {
                name: 'Harness List',
                value: 'harness_list',
                href: `/vehicles/${vehicle.vehicle_id}/harnesses`,
              },
              {
                name: 'Circuit',
                value: 'circuit',
                href: `/vehicles/${vehicle.vehicle_id}/circuit`,
              },
              {
                name: 'Device Connections',
                value: 'device_connections',
                href: `/vehicles/${vehicle.vehicle_id}/device_connections`,
              },
              {
                name: 'DTC Mapping Validation',
                value: 'dtc_mapping_validation',
                href: `/vehicles/${vehicle.vehicle_id}/dtc_mapping_validation`,
              },
              {
                name: 'Graph Missing Images',
                value: 'graph_missing_images',
                href: `/vehicles/${vehicle.vehicle_id}/graph_missing_images`,
              },
              {
                name: 'Visual Aid',
                value: 'visual_aid',
                href: `/vehicles/${vehicle.vehicle_id}/visual-aid`,
              },
            ]}
            outsideClickClose={true}
            onClick={(value) => {
              window.location.href = value.href
            }}
          >
            <LinkWithStatus
              href={`/vehicles/${vehicle.vehicle_id}/edit`}
              className="btn py-1 px-2"
              title="Delete"
              onClickFunc={() => {}}
            >
              <Menu size="1.5rem" color="white" />
            </LinkWithStatus>
          </DropDownMenu>
        </div>
      )}
    </div>
  )
}

const VehiclesTable = (props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const [state, dispatch] = useContext(NavContext)

  const { vehicles, activityLogEnabled, pagination } = props
  const [searchQuery, setSearchQuery] = useState(
    searchParams.get('search') ? searchParams.get('search') : ''
  )

  const deleteVehicle = async (vehicle_make_id) => {
    if (
      window.confirm(`Are you really wan't to delete ${vehicle_make_id}`) ==
      true
    ) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Vehicle .....',
          showLoader: true,
        },
        notification: {},
      })

      let res = await deleteRequest(
        `/api/vehicles/delete_vehicle/${vehicle_make_id}/`
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `Successfully Deleted ${vehicle_make_id}`,
          },
        })
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: `Something went wrong ${res?.msg}`,
          },
        })
      }

      props.getPaginatedData()
    }
  }

  return (
    <div className="flex flex-col pt-2 flex-grow">
      <form
        className="flex flex-col w-full space-y-2 pb-2"
        action="/vehicles"
        acceptCharset="UTF-8"
        method="get"
      >
        <div
          className={`flex space-x-5 justify-between content-center items-center`}
        >
          <div className="flex items-center w-1/2">
            <div className="flex items-center w-full">
              <InputText
                name="search"
                placeholder={`Search Make Model Id, Make, Model...`}
                className={`w-100`}
                value={searchQuery}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchQuery(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
            </div>
            <Button
              className={`cursor-pointer btn my-1 justify-end`}
              text={`Search`}
              onClick={() => {}}
            />
          </div>
          <div className="w-2/3 font-light text-right space-x-5">
            <LinkWithStatus
              href={`/vehicles/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Vehicle"
            />
            {(state?.permissions?.includes(TRACER_PREVIEW) ||
              state?.permissions?.includes(TRACER_PREVIEW_MGMT)) && (
              <Button
                type="submit"
                className={`cursor-pointer btn`}
                text={'Launch Tracer Preview'}
                onClick={() => {
                  navigate('/manage-update-list/preview?data_version=master')
                }}
              />
            )}
            {HasPermission(PROMOTE_CHANGES) && (
              <LinkWithStatus
                href={`/manage-update-list`}
                className={
                  'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
                }
                title="Manage your Updates list"
              />
            )}
          </div>
        </div>
      </form>
      <div className="flex flex-row bg-tracer-lt-blue rounded-t text-white px-3 text-sm font-light">
        <div className="w-full">Vehicle Name</div>
      </div>
      {vehicles.map((vehicle, index) => (
        <VehicleRow
          vehicle={vehicle}
          key={index}
          deleteVehicle={(vehicle_make_id) => deleteVehicle(vehicle_make_id)}
        />
      ))}
      {vehicles?.length < 1 && <NoRecordsFound loading={false} />}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            props.getPaginatedData(e)
          }}
          onClickPrev={(e) => {
            props.getPaginatedData(e)
          }}
        />
      </div>
    </div>
  )
}

VehiclesTable.propTypes = {
  vehicles: PropTypes.array.isRequired,
  activityLogEnabled: PropTypes.bool,
  searchQuery: PropTypes.string,
  pagination: PropTypes.object,
  getPaginatedData: PropTypes.func,
}

export default VehiclesTable
